/* eslint-disable */
import React, { useContext } from 'react';

// Custom Components
import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';

// Models
import modelAktivnosti from '@/models/cesta_put_aktivnosti';
import modelCestePutevi from '@/models/ceste_putevi';

// Types
import DataCentricPage from '@/ui/DataCentric/DataCentricPage';
import UserContext from '@/context/UserContext/UserContext';

type CestePuteviDataCentricPageParams = {};

const AktivnostiOdrzavanjaDataCentricPage = (
  props: CestePuteviDataCentricPageParams
) => { 
  const userContext = useContext(UserContext);
  const canEdit = userContext?.hasAnyPermission([Permissions.CestovnaInfrastrukturaEdit]);
  
  return (
    <AppPage
      titlett="cestovna_infrastruktura:page.aktivnosti_odrzavanja"
      needPermission={[Permissions.CestovnaInfrastruktura]}
    >
      <DataCentricPage
        primaryModel={modelAktivnosti}
        primaryTitleToken="titles.aktivnosti_odrzavanja"
        primaryView='default'
        secondaryModel={modelAktivnosti}
        secondaryTitleToken="titles.aktivnosti_odrzavanja_ista_cesta"
        secondaryView='default'
        baseRecordPath={modelAktivnosti.apiPath}
        childRecordRelativePath="same-path"
        geomRelativePath=""
        mapId={51}
        mapModel={modelAktivnosti}
        primaryAllowView
        primaryAllowAdd={canEdit}
        primaryAllowEdit={canEdit}
        primaryAllowDelete={canEdit}
      />
    </AppPage>
  )}

export default AktivnostiOdrzavanjaDataCentricPage;
